const getPlayerMethods = (time: number, videoLink: string, refPlayer: any) => {
  if (videoLink.includes('vk.com')) {
    refPlayer?.current?.seek(time)
    window.scrollTo(0, 0)
    return
  }

  if (videoLink.includes('yandex.')) {
    refPlayer?.current?.seek(time)
    window.scrollTo(0, 0)
    return
  }

  if (videoLink.includes('rutube.ru')) {
    refPlayer.current.contentWindow.postMessage(
      JSON.stringify({
        type: 'player:setCurrentTime',

        data: {
          time,
        },
      }),
      '*'
    )
    window.scrollTo(0, 0)
    return
  }
  refPlayer?.current?.internalPlayer?.seekTo?.(time)
  window.scrollTo(0, 0)
}

export { getPlayerMethods }
